/* INNER HEALTH · motor de movimiento v4
   Un solo archivo, cargado una vez desde theme.liquid (el guard evita dobles).
   Qué hace:
   - Revela .ih-reveal / .ih-stagger / .ih-draw / .ih-grow / .ih-dot / .ih-count al entrar en pantalla
   - Parte titulares .ih-words en palabras y las levanta una a una
   - Parallax suave en [data-parallax] (número = velocidad, ej. 0.15)
   - Cintas .ih-ticker: duplica el contenido para que el bucle sea continuo
   - Imágenes .ih-img aparecen al cargar
   - Contadores .ih-count (data-to, data-decimals, data-suffix, data-prefix)
   - Acordeones .ih-acc (details) con altura animada
   - Botones [data-ih-add] agregan al carro y abren el cajón de Dawn
   - body.ih-scrolled cuando se baja de 40 px (cabecera)
   - window.ihMoney(centavos) con el formato de la tienda ([data-money])
   - window.ihSwap(el, texto) para cambiar precios con transición
   Redes de seguridad: nada queda invisible si el observador no dispara.
*/
(function () {
  'use strict';
  if (window.__ihMotion) return;
  window.__ihMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '.ih-reveal, .ih-stagger, .ih-draw, .ih-grow, .ih-dot, .ih-count, .ih-words';

  function fmt(n, d) {
    try { return new Intl.NumberFormat('es-CL', { minimumFractionDigits: d, maximumFractionDigits: d }).format(n); }
    catch (e) { return d ? n.toFixed(d) : String(Math.round(n)); }
  }

  window.ihMoney = function (cents) {
    var el = document.querySelector('[data-money]');
    var f = el ? el.getAttribute('data-money') : (window.ihMoneyFormat || '${{amount_no_decimals}}');
    var m = f.match(/\{\{\s*(amount[^}\s]*)\s*\}\}/);
    var kind = m ? m[1] : 'amount_no_decimals';
    var comma = /with_comma_separator/.test(kind), apos = /with_apostrophe_separator/.test(kind), space = /with_space_separator/.test(kind);
    var noDec = /no_decimals/.test(kind);
    var whole = noDec ? Math.round(cents / 100) : Math.floor(cents / 100);
    var sep = comma ? '.' : apos ? "'" : space ? ' ' : ',';
    var grouped = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    if (!noDec) { var dec = String(Math.round(cents % 100)); if (dec.length < 2) dec = '0' + dec; grouped += (comma ? ',' : '.') + dec; }
    return f.replace(/\{\{\s*amount[^}]*\}\}/, grouped).replace(/<[^>]+>/g, '').trim();
  };

  window.ihSwap = function (el, text) {
    if (!el) return;
    if (reduce) { el.textContent = text; return; }
    el.classList.add('is-out');
    setTimeout(function () { el.textContent = text; el.classList.remove('is-out'); }, 140);
  };

  function count(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var to = parseFloat(el.dataset.to), d = parseInt(el.dataset.decimals || '0', 10);
    var pre = el.dataset.prefix || '', suf = el.dataset.suffix || '';
    if (isNaN(to)) return;
    if (reduce) { el.textContent = pre + fmt(to, d) + suf; return; }
    var dur = parseInt(el.dataset.dur || '1400', 10), t0 = null;
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4);
      el.textContent = pre + fmt(to * e, d) + suf;
      if (p < 1) requestAnimationFrame(step); else el.textContent = pre + fmt(to, d) + suf;
    }
    requestAnimationFrame(step);
  }

  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var i = 0;
    function walk(node) {
      var kids = [].slice.call(node.childNodes);
      kids.forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'ih-w';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains('ih-w')) { walk(n); }
      });
    }
    walk(el);
  }

  function prepDraw(root) {
    root.querySelectorAll('path, line, polyline, circle').forEach(function (p) {
      try { var len = p.getTotalLength ? Math.ceil(p.getTotalLength()) : 1200; p.style.setProperty('--len', len); } catch (e) {}
    });
  }

  function show(el) {
    el.classList.add('is-in');
    if (el.classList.contains('ih-count')) count(el);
    if (io) io.unobserve(el);
  }

  var io = null, fired = false;
  function arm() {
    document.querySelectorAll('.ih-words:not([data-split])').forEach(splitWords);
    var targets = document.querySelectorAll('.ih-reveal:not(.is-in):not([data-armed]), .ih-stagger:not(.is-in):not([data-armed]), .ih-draw:not(.is-in):not([data-armed]), .ih-grow:not(.is-in):not([data-armed]), .ih-dot:not(.is-in):not([data-armed]), .ih-words:not(.is-in):not([data-armed]), .ih-count:not([data-done]):not([data-armed])');
    if (!targets.length) return;
    document.querySelectorAll('.ih-draw:not(.is-in)').forEach(prepDraw);
    if (reduce || !('IntersectionObserver' in window)) { targets.forEach(show); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        fired = true;
        entries.forEach(function (en) { if (en.isIntersecting) show(en.target); });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    targets.forEach(function (el) { el.setAttribute('data-armed', '1'); io.observe(el); });
  }

  function safety() {
    var vh = window.innerHeight || 800;
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.classList.contains('is-in') || el.dataset.done) return;
      var r = el.getBoundingClientRect();
      if (r.bottom > -vh * 0.5 && r.top < vh * 1.5) show(el);
    });
  }
  function showAll() { document.querySelectorAll(SEL).forEach(function (el) { if (!el.classList.contains('is-in')) show(el); }); }

  function armImages() {
    document.querySelectorAll('img.ih-img:not([data-armed])').forEach(function (img) {
      img.setAttribute('data-armed', '1');
      var done = function () { img.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth > 0) done(); else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
    setTimeout(function () { document.querySelectorAll('img.ih-img:not(.is-loaded)').forEach(function (i) { if (i.complete) i.classList.add('is-loaded'); }); }, 3000);
  }

  function armTickers() {
    document.querySelectorAll('.ih-ticker:not([data-armed])').forEach(function (t) {
      t.setAttribute('data-armed', '1');
      var track = t.querySelector('.ih-ticker__track'); if (!track) return;
      var w = track.scrollWidth, need = (t.clientWidth || window.innerWidth) * 2, html = track.innerHTML, n = 1;
      while (w * n < need && n < 8) n++;
      var out = html; for (var i = 1; i < n; i++) out += html;
      track.innerHTML = out + out;
      var total = track.scrollWidth / 2, speed = parseFloat(t.dataset.speed || '60');
      track.style.setProperty('--ih-tk-dur', Math.max(12, total / speed) + 's');
    });
  }

  var pxEls = [], ticking = false;
  function armParallax() {
    pxEls = [].slice.call(document.querySelectorAll('[data-parallax]'));
    pxEls.forEach(function (el) { el.classList.add('ih-parallax'); });
    onScroll();
  }
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY || 0, vh = window.innerHeight || 800;
      document.body.classList.toggle('ih-scrolled', y > 40);
      if (reduce) return;
      pxEls.forEach(function (el) {
        var r = el.getBoundingClientRect(), mid = r.top + r.height / 2 - vh / 2;
        el.style.setProperty('--ih-py', (mid * -parseFloat(el.dataset.parallax || '0.12')).toFixed(1) + 'px');
      });
    });
  }

  function armAccordions() {
    document.querySelectorAll('details.ih-acc:not([data-armed])').forEach(function (d) {
      d.setAttribute('data-armed', '1');
      var s = d.querySelector('summary'), body = d.querySelector('.ih-acc__body');
      if (!s || !body || reduce || !body.animate) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h0 = body.offsetHeight;
          var a = body.animate([{ height: h0 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.16,1,.3,1)' });
          a.onfinish = function () { d.open = false; body.style.height = ''; };
        } else {
          d.open = true;
          var h1 = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h1 + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.16,1,.3,1)' });
        }
      });
    });
  }

  function addToCart(btn) {
    var id = btn.dataset.ihAdd, qty = parseInt(btn.dataset.qty || '1', 10);
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: qty }] };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        if (res.status && res.status >= 400) { alert(res.description || res.message || 'No se pudo agregar'); return; }
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        document.dispatchEvent(new CustomEvent('ih:added', { detail: res }));
      })
      .catch(function () { btn.removeAttribute('aria-busy'); window.location.href = '/cart'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ih-add]'); if (!b) return;
    e.preventDefault(); addToCart(b);
  });

  function boot() {
    arm(); armImages(); armTickers(); armParallax(); armAccordions();
    setTimeout(safety, 2500);
    setTimeout(function () { if (!fired && !reduce) showAll(); }, 8000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { arm(); armImages(); armTickers(); armParallax(); armAccordions(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(safety, 300); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('beforeprint', showAll);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { safety(); } });
})();
